module.exports = __webpack_public_path__ + "img/resources-1920.a55bf7d7.jpg";